module.exports = __webpack_public_path__ + "static/3-3bb6097f1db062f144aae380a4036be5.jpg";